import alberta from './alberta/'
import britishColumbia from './britishColumbia/'
import manitoba from './manitoba/'
import newBrunswick from './newBrunswick/'
import newfoundlandLabrador from './newfoundlandLabrador/'
import novaScotia from './novaScotia/'
import ontario from './ontario/'
import ontarioGTA from './ontarioGTA/'
import saskatchewan from './saskatchewan/'

export default [
  alberta,
  britishColumbia,
  saskatchewan,
  ontarioGTA,
  ontario,
  newfoundlandLabrador,
  manitoba,
  newBrunswick,
  novaScotia
]



// WEBPACK FOOTER //
// ./src/store/provinces/index.js